// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-panel_wrapper__m3Y6y {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}
.transcript-panel_wrapper__m3Y6y button {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;

    border: none;

    font: inherit;
    font-size: 12px;
    color: var(--textColor);

    background: none;
    outline: none;
  }
.transcript-panel_wrapper__m3Y6y button:focus-visible {
      outline: 2px solid var(--primaryColor);
    }
.transcript-panel_wrapper__m3Y6y .transcript-panel_content__mLSOz {
    overflow: auto;
    display: flex;
    flex-direction: column;

    min-height: 0px;
    padding: 2px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/transcript/transcript-panel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AA4BlB;AA1BE;IACE,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;;IAEjB,YAAY;;IAEZ,aAAa;IACb,eAAe;IACf,uBAAuB;;IAEvB,gBAAgB;IAChB,aAAa;EAKf;AAHE;MACE,sCAAsC;IACxC;AAGF;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;;IAEtB,eAAe;IACf,YAAY;EACd","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n\n  & button {\n    cursor: pointer;\n    user-select: none;\n\n    border: none;\n\n    font: inherit;\n    font-size: 12px;\n    color: var(--textColor);\n\n    background: none;\n    outline: none;\n\n    &:focus-visible {\n      outline: 2px solid var(--primaryColor);\n    }\n  }\n\n  & .content {\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n\n    min-height: 0px;\n    padding: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `transcript-panel_wrapper__m3Y6y`,
	"content": `transcript-panel_content__mLSOz`
};
export default ___CSS_LOADER_EXPORT___;
